const locale = {
  CLIENTS: 'Clients',
  ORDERS: 'Orders',
};

export default locale;
